import { Accept, ErrorCode } from 'react-dropzone';

import isPlural from '@/helpers/isPlural';

export interface FileWithPreview extends File {
  preview: string;
}

export const getErrorMessage = ({
  errorCode,
  maxFiles,
  maxSize,
  acceptedFileTypes,
}: {
  errorCode: ErrorCode;
  acceptedFileTypes?: Accept;
  maxFiles?: number;
  maxSize?: number;
}) => {
  const errorMessages: Record<ErrorCode, string> = {
    'file-invalid-type': acceptedFileTypes
      ? `File needs to be one of ${Object.values(acceptedFileTypes).join(', ')}`
      : 'Invalid file type',
    'file-too-large': maxSize ? `Maximum file size is ${maxSize / 10000} MB` : 'File too large',
    'file-too-small': 'File too small',
    'too-many-files': maxFiles
      ? `Only ${maxFiles} ${isPlural({ one: 'file', more: 'files', number: maxFiles })}`
      : 'Too many files',
  };

  return errorMessages[errorCode];
};

export const createFilePreview = (file: File): FileWithPreview => {
  return Object.assign(file, {
    preview: URL.createObjectURL(file),
  });
};

export const formatFileSize = (bytes?: number) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
